module.exports = __webpack_public_path__ + "images/buttons/join-partner-program-big.png";